<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

type LinkVariant = 'footer' | 'topbar' | 'colored' | 'breadcrumb';

const props = defineProps<{
  href?: string
  to?: RouteLocationRaw
  tag?: string
  text?: string
  variant: LinkVariant
  icon?: boolean
}>();

const variantClasses: Record<LinkVariant, string> = {
  footer: 'text-sm',
  topbar: 'font-semibold',
  colored: 'font-semibold text-primary-40 hover:text-primary-30',
  breadcrumb: 'text-xs',
} as const;

const classes = computed(() => {
  const _classes = [variantClasses[props.variant]];
  _classes.push('hover:underline decoration-1');
  if (props.icon) {
    _classes.push('aspect-square !px-0');
  };
  return _classes;
});

const { linkComponent, linkBindings } = useLinksBuilder(props);
</script>

<template>
  <component
    :is="linkComponent"
    v-bind="linkBindings"
    class="inline-flex items-center"
    :class="classes"
  >
    <slot>
      {{ text }}
    </slot>
  </component>
</template>
